import { Injectable } from '@angular/core';

/**
 * Service for working with data as it relates to displaying in a Data Table
 */
@Injectable()
export class DataTableService {
	/**
	 * Sort data in response to an event from the data table
	 * @param event - the event from the data table
	 * @param tabObject - the tab object with the data
	 * @param reloadCallback - the function to re-load the data now that sorting has been set
	 */
	tableSort(event, tabObject, reloadCallback) {
		try {
			tabObject['sortParam'] = event.sorts[0].prop;
			tabObject['sortDir'] = event.sorts[0].dir;
			tabObject['page'] = 0;
			reloadCallback(tabObject);
		} catch {
			console.error("Data Table failed to sort.");
		}
	}
}
